import '@/style.css'
import { createApp } from 'vue'
import { setupStore } from '@/store'
import { setupRouter } from './router'
import Vconsole from 'vconsole'
import '@/plugins/unocss'
import { ElDialog } from 'element-plus'
import App from './App.vue'
import { initImgIcon } from '@/components/Icon/tool.ts'
// ------- 路由守卫，顺序不要改变 -------
import '@/router/permission-before.ts'
import '@/router/env-before.ts'
import '@/router/watch-before.ts'
import axios from 'axios'
// -----------------------------------

console.log('import.meta.env.VITE_USER_NODE_ENV', import.meta.env.VITE_USER_NODE_ENV)
if (import.meta.env.VITE_USER_NODE_ENV !== 'production') {
  new Vconsole()
}

const liveConfigJsonUrl = import.meta.env.VITE_LIVE_CONFIG_JSON_URL

axios(liveConfigJsonUrl)
  .then(res => {
    sessionStorage.setItem('globalLiveConfig', JSON.stringify(res.data || {}))
  })
  .finally(() => {
    const app: any = createApp(App)

    setupStore(app)
    setupRouter(app)

    app.mount('#app')

    // 图片预加载
    initImgIcon().then()
  })

// 全局修改默认配置，点击空白处不能关闭弹窗
ElDialog.props.closeOnClickModal.default = false
// 全局修改默认配置，按下ESC不能关闭弹窗
ElDialog.props.closeOnPressEscape.default = false
